import React from "react";
import { Switch, Route } from "react-router";
import ReturnsIndexPage from "pages/fulfillment/ReturnsIndexPage";
import ReturnDetailsPage from "pages/fulfillment/ReturnDetailsPage";

const ReturnsRouter = () => {
  return (
    <Switch>
      <Route exact path="/organizations/:organization_id/returns" component={ReturnsIndexPage} />
      <Route path="/organizations/:organization_id/returns/:return_id" component={ReturnDetailsPage} />
    </Switch>
  );
};

export default ReturnsRouter;
